function filterEmptyLines(textsByLine: string[]) {
  return textsByLine.filter((text) => text !== '');
}

export default function countTextEditorLines(textsByLine?: string[]): number {
  if (!textsByLine) {
    return 0;
  }

  if (textsByLine.length < 1) {
    return 0;
  }

  return filterEmptyLines(textsByLine).reduce(
    (previous, current) => previous + Math.floor(current.length / 80) + 1,
    0,
  );
}
